import api from './api';

export interface Comment {
  id: string;
  taskId: string;
  authorId: string;
  authorName: string;
  content: string;
  parentCommentId?: string;
  replies: Comment[];
  createdAt: string;
  updatedAt?: string;
  lastUpdatedAt?: string;
}

export interface CreateCommentDto {
  taskId: string;
  content: string;
  parentCommentId?: string;
}

export interface UpdateCommentDto {
  content: string;
}

const commentService = {
  // Get comments for a task
  getTaskComments: async (taskId: string): Promise<Comment[]> => {
    const response = await api.get<Comment[]>(`/comments/${taskId}`);
    return response.data;
  },

  // Create comment
  createComment: async (data: CreateCommentDto): Promise<Comment> => {
    const response = await api.post<Comment>('/comments', data);
    return response.data;
  },

  // Update comment
  updateComment: async (id: string, data: UpdateCommentDto): Promise<Comment> => {
    const response = await api.put<Comment>(`/comments/${id}`, data);
    return response.data;
  },

  // Delete comment
  deleteComment: async (id: string): Promise<void> => {
    await api.delete(`/comments/${id}`);
  },
};

export default commentService;
